import { ILeadSubscriptionItem } from 'models/lead.model'
import { getHasActiveSubscriptionStatus } from './getHasActiveSubscriptionStatus'

export const getHasBasicSubscription = (
  subscriptions: ILeadSubscriptionItem[] | null,
): boolean =>
  !!subscriptions?.find(
    ({ planOnboardingType, status }) =>
      (planOnboardingType === 'purchase' ||
        planOnboardingType === 'cancelOffer') &&
      getHasActiveSubscriptionStatus(status),
  )
